let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8UtWs")).then(() => parcelRequire('95IG1'));